import { PageHeading, TeamHeading } from "@/components/Layout/Parts";
import DistributionProjectTable from "./components/DistributionProjectTable";

const DistributionProjectSummary = () => {
  return (
    <>
      <TeamHeading />
      <PageHeading>Project Summary</PageHeading>
      <DistributionProjectTable />
    </>
  );
};

export default DistributionProjectSummary;
